import {createContext, useEffect, useState} from "react";
import {ThemeProvider} from "styled-components";
import {themes} from "../components/Theme/Theme";
import {getFromLS, setToLS} from "../utils/storage";

const themeContextInitState = {
  theme: themes.light,
  toggleTheme: () => {}
}

const LIGHT_THEME = "light";
const DARK_THEME = "dark";

const ThemeContext = createContext(themeContextInitState);

const MyThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(getFromLS('theme') || LIGHT_THEME);
  const toggleTheme = () => {
    setTheme(theme === LIGHT_THEME ? DARK_THEME : LIGHT_THEME);
  };

  useEffect(() => {
    setToLS('theme', theme);
  }, [theme])

  return (
    <ThemeContext.Provider
      value={{
        theme,
        toggleTheme
      }}
    >
      <ThemeProvider theme={theme === LIGHT_THEME ? themes.light : themes.dark}>
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export { MyThemeProvider, ThemeContext, LIGHT_THEME, DARK_THEME };
